var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLdo0)",
    d: "m12 13.372l-4.393-2.58l-.124.188a5.434 5.434 0 0 0 .728 6.724a5.335 5.335 0 0 0 7.577 0a5.42 5.42 0 0 0 .729-6.724l-.124-.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLdo1)",
    d: "m16.371 10.8l-4.358 2.563L7.624 10.8l4.389-2.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLdo2)",
    d: "m12.004 3.797l3.789 5.979L12.004 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedLdo3)",
    d: "M12.004 3.797V12L8.215 9.772z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLdo0",
    x1: 12,
    x2: 12,
    y1: 3.797,
    y2: 19.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#498BE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLdo1",
    x1: 11.999,
    x2: 11.999,
    y1: 3.811,
    y2: 19.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5ABEF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLdo2",
    x1: 13.142,
    x2: 11.033,
    y1: 12.406,
    y2: 19.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB8174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#568FDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedLdo3",
    x1: 9.017,
    x2: 9.703,
    y1: 7.899,
    y2: 11.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5DCBA2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdo);
export default __webpack_public_path__ + "static/media/ldo.31352c31aee0eef460202da13ab40096.svg";
export { ForwardRef as ReactComponent };